// Moved out of QuickFitlerListCreatorPage during [LIST-666] since
// usePathwaySteps is used in 2 other places now. Brought
// usePrefetchPathwaySteps() hook across too because it looked lonely
import { useAuth0 } from '@auth0/auth0-react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getPathwaySteps } from '@/apis/pathways';
import { environment } from '@/config';
import { PATHWAY_STEPS_QUERY_KEY } from '@/constants';

export const usePathwaySteps = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery<{ label: string; id: number }[]>({
    queryKey: PATHWAY_STEPS_QUERY_KEY,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return getPathwaySteps(token);
    },
    staleTime: Infinity,
  });
};

export const usePrefetchPathwaySteps = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  if (environment !== 'test')
    queryClient.ensureQueryData({
      queryKey: PATHWAY_STEPS_QUERY_KEY,
      queryFn: async () => {
        const token = await getAccessTokenSilently();
        return getPathwaySteps(token);
      },
    });
};
